import React from 'react';
import {
    SimpleForm, TextInput, SelectInput, Edit, Toolbar,
    NumberInput, SaveButton, usePermissions
} from 'react-admin';
import {
    CodStatoUsoChoices, Statuses, ReverseChoices,
    Anomalie_Magazziniere, CausaliChoices
} from '../objects';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const DeviceTitle = ({ record }) => {
    return <span>Apparato {record ? `${record.serial_number_tim}` : ''}</span>;
};

const DeviceToolbar = ({ ...props }) => {
    return <Toolbar {...props} classes={useStyles()} >
                <SaveButton disabled={true} />
    </Toolbar>
};

function DeviceScaricatoEdit() {
    const permissions = usePermissions().permissions;

    return (
        <Edit title={<DeviceTitle />}>
            <SimpleForm toolbar={<DeviceToolbar permissions={permissions} scope={this} />}>
                <SelectInput source="status.codice" label='Stato' choices={Statuses} disabled />   
                <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie_Magazziniere} disabled />
                <TextInput source="serial_number_tim" disabled />
                <TextInput source="serial_number_forn" disabled />
                <TextInput source="mac_address" disabled />
                <TextInput source="externalrefid" sx={{ display: 'none' }} />
                <NumberInput source="workrequestid" id="workrequestid" disabled />
                <TextInput source="impianto" disabled />
                <TextInput source="impianto_regman" disabled />
                <TextInput source="status_regman.descrizione" disabled />
                <TextInput source="serial_number_cpe" disabled />
                <TextInput source="codice_impresa_name" disabled />
                <TextInput source="tipo_task" sx={{ display: 'none' }} />
                <TextInput source="wr_prodotti" sx={{ display: 'none' }} />
                <TextInput source="cod_proj" sx={{ display: 'none' }} />
                <TextInput source="client_type" sx={{ display: 'none' }} />
                <TextInput source="resource_id" sx={{ display: 'none' }} />
                <TextInput source="area" sx={{ display: 'none' }} />
                <TextInput source="cod_terr_sap" disabled />
                <TextInput source="num_consegna" disabled />
                <SelectInput source="cod_stato_uso.codice" choices={CodStatoUsoChoices} disabled />
                <SelectInput source="reverse.codice" label="Reverse" choices={ReverseChoices} disabled />
                <TextInput source="causale.codice" sx={{ display: 'none' }} />
                <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} disabled />
                <TextInput source="note" rowsMax={8} multiline maxWidth="500" disabled/>
            </SimpleForm>
        </Edit>
    );
}

export default DeviceScaricatoEdit;